import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import { ConfirmDeleteModal } from '../../../components';
import { foodTypeActions } from '../../../redux';

interface Props {
  closeModal: () => void;
  isOpen: boolean;
  id: string;
}

const DeleteFoodTypeModal: FC<Props> = ({ closeModal, isOpen, id }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(foodTypeActions.deleteFoodTypes(id));
    closeModal();
  };

  return (
    <ConfirmDeleteModal
      isOpen={isOpen}
      title='lblDeleteFoodType'
      closeModal={closeModal}
      onDeleteConfirmed={handleDelete}
      description='lblConfirmDeleteFoodType'
    />
  );
};
export default DeleteFoodTypeModal;
